module.exports = __webpack_public_path__ + "6dc46be94b57e5a6f1ef00019320e6dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/blackrock_ishares.png
// module id = 1404
// module chunks = 0